import { useBreakoutRoomInviteGql } from './breakoutRoomInvite/breakoutRoomInviteGql';
import {
  breakoutRoomInviteSchema,
  statusEnum,
  invitationTypesEnum,
} from './breakoutRoomInvite/breakoutRoomInviteSchema';

export const breakoutRoomInviteModel = {
  gql: useBreakoutRoomInviteGql(),
  schema: breakoutRoomInviteSchema,
  enums: {
    status: statusEnum,
    invitationTypes: invitationTypesEnum,
  },
};
